import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import Root from "./components/Root/Root";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCnmBvFNtMWLRlayQl_7UFrs5J4U063z5I",
  authDomain: "mutual-fund-demo.firebaseapp.com",
  projectId: "mutual-fund-demo",
  storageBucket: "mutual-fund-demo.appspot.com",
  messagingSenderId: "86756672807",
  appId: "1:86756672807:web:5633647f77aebed9fb9502"
};

// Initialize Firebase
initializeApp(firebaseConfig);